import { createContext } from 'react';
import { UsersHostProps } from './types';

export type UsersContextValue = Omit<UsersHostProps, 'title'>;

export const UsersContext = createContext<UsersContextValue | null>(null);
